var mainVideoBg = {};
var mainVideoBgReady = {mainMovie: false, layerMovie1: false, layerMovie2: false};
var mainMotion = new TimelineMax({paused:true});
var gnbMotion = new TimelineMax({paused:true});

var setMotion = function(){
	mainMotion.addLabel('init').from($(".main_tit"), 1.1, {alpha: 0, scale: 1.15, ease: Power3.easeOut}, "init+=0.2")
	.staggerFrom($(".main_stit > span"), 0.35, {y: -20, alpha: 0, ease: Circ.easeOut}, 0.1, "init+=0.5")
	.from($(".main_txt"), 0.8, {scale: 1.2, alpha: 0, ease: Power3.easeOut}, "init+=1.15")
	.from($(".btn_main_play1"), 0.62, {scale: 0.85, alpha: 0, ease: Power3.easeOut}, "init+=1.65")
	.from($(".btn_main_play2"), 0.62, {scale: 0.85, alpha: 0, ease: Power3.easeOut}, "init+=1.9")
	.add(() => {
		TweenMax.fromTo(".scroll_txt", 1, {opacity: 0, y: 10}, {opacity: 1, y: 0, yoyo: !0, repeat: -1, delay: 2.2, ease: Power2.easeOut});
	},"init+=0.78")
	.from($(".badge"), 0.62, {alpha: 0, ease: Power3.easeOut}, "init+=0.78")
	.staggerFrom($(".etc_menu>li"), 0.35, {x: 60, alpha: 0, ease: Circ.easeOut}, 0.1, "init+=0.68");

	gnbMotion.to($(".gnb"), 1, {height: 215, alpha:1, ease: Power3.easeOut}, 0.1)
	.staggerFrom($(".gnb>li"), 0.45, {x: 60, alpha: 0, ease: Circ.easeOut}, 0.1, "-=1.4");
};


var init = function () {
    setVideo();
    moviePlay("mainMovie");

    $(".btn_play").on("click", function () {
		var idx = $(this).data('movie');
        movieLayer("open", idx);
    });

    $(".moovie_close").on("click", function () {
        var idx = $(this).data('movie');
		movieLayer("close", idx);
    });

	$(".btn_close_badge").on("click", function () {
		$(".badge").hide();
    });


};

function movieLayer(stateChk, idx) {
    if (stateChk == "open") {
		if(idx === 1){
			$(".layer_movie_1").fadeIn();
			moviePlay("layerMovie1");
		}else{
			$(".layer_movie_2").fadeIn();
			moviePlay("layerMovie2");
		}
        mainVideoBg.mainMovie.pause();
        $(window).trigger('resize');
    } else if (stateChk == "close") {
		if(idx === 1){
			mainVideoBg.layerMovie1.seek(0);
			mainVideoBg.layerMovie1.pause(0);
			mainVideoBg.mainMovie.play();
			$(".layer_movie_1").fadeOut();
		}else{
			mainVideoBg.layerMovie2.seek(0);
			mainVideoBg.layerMovie2.pause(0);
			mainVideoBg.mainMovie.play();
			$(".layer_movie_2").fadeOut();
		}
    }
}

function moviePlay(idxId) {
    if (mainVideoBgReady[idxId]) {
        mainVideoBg[idxId].play();
        return;
    }
    var checkReady = setInterval(function () {
        mainVideoBgReady[idxId] = mainVideoBg[idxId].state.isReady;
        if (mainVideoBgReady[idxId]) {
            mainVideoBg[idxId].play();
            clearInterval(checkReady);
        }
    }, 100);
}

function setVideo() {
    mainVideoBg.mainMovie = new nc.promokit.Player({
        selector: '#main-1',
        videoId: 'https://vod.plaync.com/BS/old/180912_awaken/bnS_Job_low.mp4',
        mute: true,
        autoPlay: false,
        loop: true
    });

    mainVideoBg.layerMovie1 = new nc.promokit.Player({
        selector: '#movieBox-1',
        videoId: '-g6-p2ek2eM',
        mute: false,
        autoPlay: false,
        controls: true,
		coverClick: true
    });

	mainVideoBg.layerMovie2 = new nc.promokit.Player({
        selector: '#movieBox-2',
        videoId: 'zWxzq4MbZeY',
        mute: false,
        autoPlay: false,
        controls: true,
		coverClick: true
    });
}

function resetMovie() {
    $.each(mainVideoBg, function (key, value) {
        if (value !== null) {
            if (value.state.isReady) {
                value.seek(0);
                value.pause(0);
            }
        }
    });
}


const onStart = () => {

};

const onComplete = () => {

};

let initAnimation = false;


const onAnimation = () => {
    $(window).trigger("resize");
	if (!initAnimation) {
		initAnimation = true;
		setMotion();
	}else{
		mainMotion && mainMotion.seek(0);
		mainMotion && mainMotion.pause(0);
        mainVideoBg.mainMovie.play();
	}

	setTimeout(() => {
        mainMotion.play();
		gnbMotion.play();
    }, 1500)
};

const closeAnimation = () => {
	TweenMax.killTweensOf('.scroll_txt');
	$('.scroll_txt').removeAttr('style');
}
const mainResetMovie = () => {
    mainVideoBg.mainMovie && mainVideoBg.mainMovie.pause();
};

const mainInit = () => {
    init();
};

export default {
    onStart,
    onComplete,
    onAnimation,
    mainResetMovie,
    mainInit,
	closeAnimation
};



// WEBPACK FOOTER //
// ./src/js/page/main.js